import { Outlet } from 'react-router-dom';
import { Header } from '../components/Header';
import { StepProgress } from '../components/StepProgress';

export function MainLayout() {
  return (
    <div className="min-h-screen bg-swiss-pearl">
      <Header />
      <StepProgress />
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}